import config from './config';

import queryString from '@spotim/fed-utils/query-string';
import endpoints from 'app/libraries/fed-resources/endpoints/social-connect';

export function getConnectUrl(socialNetwork, token, sourceUrl, { spotId, networkId }) {
  socialNetwork = socialNetwork.toLowerCase();
  if (['facebook', 'google', 'linkedin', 'twitter', 'vk', 'disqus'].indexOf(socialNetwork) === -1) {
    throw new Error(`Social connect doesn't support ${socialNetwork} socialNetwork`);
  }

  socialNetwork = `${socialNetwork}-connect`;
  var { socialLoginCallbackUrl: callbackUrl, socialLoginCancelUrl: cancelUrl } = config;
  sourceUrl = queryString.buildUrl(sourceUrl, { spot_im_social_network: socialNetwork });
  callbackUrl = queryString.buildUrl(callbackUrl, { source_url: sourceUrl });
  cancelUrl = queryString.buildUrl(cancelUrl, { source_url: sourceUrl });

  var url;
  if (spotId) {
    url = endpoints.connectBySpotId.getFullUrl({ socialNetwork, token, spotId });
  } else if (networkId) {
    url = endpoints.connectByNetworkId.getFullUrl({ socialNetwork, token, networkId });
  } else {
    throw new Error('Social connect requires spotId or networkId');
  }

  url = `${url}&callback_url=${encodeURIComponent(callbackUrl)}&cancel_url=${encodeURIComponent(cancelUrl)}`;

  if (spotId) {
    url = `${url}&spot_id=${encodeURIComponent(spotId)}`;
  }

  return url;
}
